/**
 * CountdownTimer — Timer regressivo com Dias/Horas/Min/Seg
 */
import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { T } from '../../styles/tokens';

export interface CountdownTimerProps {
  startsAt: string;
  textColor?: string;
}

export function CountdownTimer({ startsAt, textColor }: CountdownTimerProps) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const target = new Date(startsAt).getTime();
  const diff = Math.max(0, target - now);
  const dias = Math.floor(diff / 86400000);
  const hrs = Math.floor((diff % 86400000) / 3600000);
  const min = Math.floor((diff % 3600000) / 60000);
  const seg = Math.floor((diff % 60000) / 1000);
  const pad = (n: number) => String(n).padStart(2, '0');

  return (
    <div style={{ display: 'flex', gap: 10, justifyContent: 'center', margin: '12px 0' }}>
      {[
        { v: pad(dias), l: 'Dias' },
        { v: pad(hrs), l: 'Horas' },
        { v: pad(min), l: 'Min' },
        { v: pad(seg), l: 'Seg' },
      ].map((item) => (
        <div key={item.l} style={{ textAlign: 'center' }}>
          <div style={{
            background: T.blackAlpha30, borderRadius: 10, padding: '8px 12px',
            fontSize: 26, fontWeight: 700, fontFamily: 'monospace', minWidth: 48,
            color: textColor || '#fff',
          }}>{item.v}</div>
          <div style={{ fontSize: 11, opacity: 0.7, marginTop: 4, color: textColor || '#fff' }}>{item.l}</div>
        </div>
      ))}
    </div>
  );
}
